import React, {
  Children,
  cloneElement,
  isValidElement,
  useEffect,
  useState,
} from "react";
import { Link, useLocation } from "react-router-dom";

// Mobile replacement for the SecondaryNav sidebar in vaboo-ui/PageContainer,
// which is `hidden md:flex` and therefore invisible on a phone — taking every
// sub-section (client imports, invoices, users, custom links, ...) with it.
// Here the same `page.nav` is rendered as a collapsible bar under the topbar.
const MobilePageContainer = ({
  page,
  entityDetails = null,
  navHeader = null, // eslint-disable-line no-unused-vars -- see note below
  navAction = null,
  children,
}) => {
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    setIsOpen(false);
  }, [location.pathname]);

  const nav = page?.nav || [];
  const activeItem = nav.find((item) => item.isActive);

  const renderNotice = (item) => (
    <React.Fragment>
      {entityDetails?.has_overdue_unpaid_invoice &&
        item.notice === "has_overdue_unpaid_invoice" && (
          <span className="mdi mdi-alert vb-m-notice-alert"></span>
        )}
      {entityDetails?.payment_system && item.notice === "payment_system" && (
        <img
          className="vb-m-notice-img"
          alt="Method"
          src={
            entityDetails?.payment_system === "Stripe"
              ? "/images/stripe.png"
              : entityDetails?.payment_system === "GoCardless"
              ? "/images/gocardless.png"
              : "/images/false-mark.png"
          }
        />
      )}
    </React.Fragment>
  );

  return (
    <div className="vb-m-page">
      {nav.length > 0 && (
        <div className="vb-m-sectionbar">
          {
            // `navHeader` is deliberately not rendered here. The only page
            // that supplies one (pages/Client.jsx) builds a banner with
            // desktop geometry — `absolute`, `mt-[-56px]`, `h-[57px]` — sized
            // against the 160px sidebar, so it detaches on a narrow viewport.
            // The section button below carries the same context instead.
            <button
              type="button"
              className="vb-m-sectionbtn"
              aria-expanded={isOpen}
              onClick={() => setIsOpen((open) => !open)}
            >
              <span className="vb-m-sectionlabel">
                <span className="vb-m-sectionroot">{page?.title}</span>
                {activeItem && (
                  <span className="vb-m-sectioncurrent">{activeItem.name}</span>
                )}
              </span>
              <span
                className={`mdi mdi-chevron-down vb-m-chev ${
                  isOpen ? "vb-m-chev-open" : ""
                }`}
              ></span>
            </button>
          }

          {isOpen && (
            <div className="vb-m-sectionmenu">
              {nav.map((item, key) => (
                <Link
                  key={key}
                  to={item.url}
                  className={`vb-m-sectionitem ${
                    item.isActive ? "vb-m-sectionitem-active" : ""
                  }`}
                >
                  <span className="vb-m-sectionitemlabel">{item.name}</span>
                  {renderNotice(item)}
                </Link>
              ))}
              {navAction && (
                <div className="vb-m-sectionaction">{navAction}</div>
              )}
            </div>
          )}
        </div>
      )}

      <div className="vb-m-content">
        {Children.map(children, (child) => {
          if (!isValidElement(child)) return null;
          return cloneElement(child, {
            ...child.props,
            entityDetails: entityDetails,
          });
        })}
      </div>
    </div>
  );
};

export default MobilePageContainer;
